/* GolfSims Theme JS */

// Cart
class GSCart {
  static async add(variantId, quantity, properties){
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1, properties: properties || {} })
    });
    return res.json();
  }

  static async get(){
    const res = await fetch('/cart.js');
    return res.json();
  }

  static async update(updates){
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    return res.json();
  }
}

// Cart drawer
document.addEventListener('DOMContentLoaded', function(){

  // Open cart drawer
  document.querySelectorAll('[data-cart-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      document.getElementById('gsCartDrawer').classList.add('open');
      document.body.classList.add('drawer-open');
      refreshCartDrawer();
    });
  });

  // Close cart drawer
  document.querySelectorAll('[data-cart-close]').forEach(function(btn){
    btn.addEventListener('click', function(){
      document.getElementById('gsCartDrawer').classList.remove('open');
      document.body.classList.remove('drawer-open');
    });
  });

  // Cart overlay click
  var overlay = document.getElementById('gsCartOverlay');
  if(overlay){
    overlay.addEventListener('click', function(){
      document.getElementById('gsCartDrawer').classList.remove('open');
      document.body.classList.remove('drawer-open');
    });
  }

  // Scroll reveal
  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('visible'); }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.scroll-reveal').forEach(function(el){ observer.observe(el); });

});

async function refreshCartDrawer(){
  const cart = await GSCart.get();
  const countEls = document.querySelectorAll('[data-cart-count]');
  countEls.forEach(function(el){ el.textContent = cart.item_count; });

  const drawer = document.getElementById('gsCartItems');
  if(!drawer) return;

  if(cart.item_count === 0){
    drawer.innerHTML = '<p class="cart-empty">Your cart is empty. <a href="/collections/all">Start shopping →</a></p>';
    return;
  }

  let html = '';
  cart.items.forEach(function(item){
    html += `
      <div class="cart-item" data-key="${item.key}">
        <img src="${item.image}" alt="${item.title}" class="cart-item__img">
        <div class="cart-item__info">
          <div class="cart-item__title">${item.product_title}</div>
          <div class="cart-item__variant">${item.variant_title || ''}</div>
          ${Object.keys(item.properties || {}).filter(k => !k.startsWith('_')).map(k => `<div class="cart-item__prop">${k}: ${item.properties[k]}</div>`).join('')}
          <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
        </div>
        <button class="cart-item__remove" onclick="removeCartItem('${item.key}')">×</button>
      </div>`;
  });

  drawer.innerHTML = html;

  const total = document.getElementById('gsCartTotal');
  if(total) total.textContent = formatMoney(cart.total_price);
}

async function removeCartItem(key){
  await GSCart.update({ [key]: 0 });
  refreshCartDrawer();
}

function formatMoney(cents){
  return '$' + (cents / 100).toFixed(2);
}

// Add to cart with feedback
document.addEventListener('submit', async function(e){
  if(!e.target.matches('[data-cart-form]')) return;
  e.preventDefault();

  const form = e.target;
  const btn = form.querySelector('[type="submit"]');
  const originalText = btn.innerHTML;

  btn.disabled = true;
  btn.innerHTML = '<span class="spinner"></span>';

  try {
    const formData = new FormData(form);
    const id = formData.get('id');
    const quantity = parseInt(formData.get('quantity')) || 1;
    const properties = {};
    formData.forEach(function(val, key){
      if(key.startsWith('properties[') && key.endsWith(']')){
        properties[key.slice(11, -1)] = val;
      }
    });

    await GSCart.add(id, quantity, properties);
    btn.innerHTML = '✓ Added!';
    btn.style.background = 'linear-gradient(135deg, #4a7c59, #5a8f6a)';

    setTimeout(function(){
      btn.innerHTML = originalText;
      btn.disabled = false;
      btn.style.background = '';
    }, 2000);

    refreshCartDrawer();
    document.getElementById('gsCartDrawer').classList.add('open');
    document.body.classList.add('drawer-open');

  } catch(err) {
    btn.innerHTML = 'Error — try again';
    btn.disabled = false;
    setTimeout(function(){ btn.innerHTML = originalText; }, 2000);
  }
});
